import { KeyboardEvent, ReactNode } from 'react';
import { FaCirclePlus } from 'react-icons/fa6';
import { AddCardRoot, EntityCardRoot } from './settingsEntities.styles';

type EntityCardProps = {
  onClick?: () => void;
  ariaLabel?: string;
  minHeight?: number;
  children: ReactNode;
};

export const EntityCard = ({ onClick, ariaLabel, minHeight, children }: EntityCardProps) => {
  const clickable = !!onClick;

  const handleKeyDown = (e: KeyboardEvent) => {
    if (e.target !== e.currentTarget) return;
    if (onClick && (e.key === 'Enter' || e.key === ' ')) {
      e.preventDefault();
      onClick();
    }
  };

  return (
    <EntityCardRoot
      clickable={clickable}
      minHeight={minHeight}
      onClick={onClick}
      role={clickable ? 'button' : undefined}
      tabIndex={clickable ? 0 : undefined}
      aria-label={ariaLabel}
      onKeyDown={clickable ? handleKeyDown : undefined}
    >
      {children}
    </EntityCardRoot>
  );
};

type AddEntityCardProps = {
  label: string;
  onClick: () => void;
  icon?: ReactNode;
  minHeight?: number;
};

export const AddEntityCard = ({ label, onClick, icon, minHeight }: AddEntityCardProps) => (
  <AddCardRoot type="button" onClick={onClick} minHeight={minHeight} aria-label={label}>
    {icon ?? <FaCirclePlus size={34} />}
    <span>{label}</span>
  </AddCardRoot>
);

export default EntityCard;
